export function getPageTemplate( typeCode:any, subTypeCode:any, formsList: any) {

    return getemplateConfig(typeCode, subTypeCode, getFormTemplate(formsList));
}
export function getFormTemplate(formsList: any) {
  return {
    disableAction: false,
     selectedForm: {
      disableBuilderFunction: true
    },
    forms: [
      {
        stageCode: "INITIATION",
        stageName: "Initiation",
        eventCode: "General",
        eventName: "Default",
        form: null,
        fgForm: formsList,
      },
    ],
  };
}

function getemplateConfig(typeCode:any, subTypeCode:any, formTemplate:any) {
  return {
    typeCode: typeCode,
    subTypeCode: subTypeCode,
    uuid: "c98ba5f0-c114-4305-80c1-6f104cd78fdb",
    template:  JSON.stringify(formTemplate),
  };
}
